import { render, staticRenderFns } from "./Under18Team.vue?vue&type=template&id=414cb19f&scoped=true"
import script from "./Under18Team.vue?vue&type=script&lang=js"
export * from "./Under18Team.vue?vue&type=script&lang=js"
import style0 from "./Under18Team.vue?vue&type=style&index=0&id=414cb19f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414cb19f",
  null
  
)

export default component.exports